<!-- 单项选择题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select" :class="topicInfo.showAnalysis ? 'topic_select_none' : ''">
            <div class="topic_type">{{ topicInfo.questionTypeName }}</div>
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
                <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
                    <div class="mr-10">音频：</div><audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
                </div>
                <div>
                    <div class="my-20">请完成下面的小题</div>
                    <div v-for="(item, index) in topicInfo.questionContext?.subQuestions" :key="index">
                        <!-- 单选 -->
                        <choice v-if="item.type == 1" :questionInfo="item" @answerQuestion="answerQuestion"
                            :disabled="topicInfo.showAnalysis"></choice>
                        <!-- 多选 -->
                        <multipleChoice v-else-if="item.type == 2" :questionInfo="JSON.stringify(item)"
                            @answerQuestion="answerQuestion" :disabled="topicInfo.showAnalysis"></multipleChoice>
                        <!-- 判断 -->
                        <trueOrFalse v-else-if="item.type == 4" :questionInfo="item" @answerQuestion="answerQuestion"
                            :disabled="topicInfo.showAnalysis">
                        </trueOrFalse>
                        <!-- 排序 -->
                        <sortNew v-else-if="item.type == 6" :questionInfo="item" @answerQuestion="answerQuestion"
                            :disabled="topicInfo.showAnalysis">
                        </sortNew>
                        <!-- 填空题 -->
                        <fillIn v-else-if="item.type == 3" :questionInfo="item" @answerQuestion="answerQuestion"
                            :disabled="topicInfo.showAnalysis">
                        </fillIn>
                        <!-- 书写解答题 -->
                        <textAnswer v-else-if="item.type == 7" :questionInfo="item" @answerQuestion="answerQuestion"
                            :disabled="topicInfo.showAnalysis">
                        </textAnswer>
                        <div
                            v-else-if="item.type != 1 && item.type != 2 && item.type != 3 && item.type != 4 && item.type != 6 && item.type != 7">
                            <moe-empty url="development_icon.png" emptyText="更多题型开发中"></moe-empty>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_box flex flexcolumn Flexalign mt-20" v-if="!topicInfo.showAnalysis">
            <div class="btn_view cursor_pointer" @click.stop="submit">提交</div>
            <div class="view_analysis cursor_pointer" @click.stop="viewAnalysis">查看解析</div>
        </div>
        <div class="topic_answer mt-20" v-if="topicInfo.showAnalysis">
            <div class="answer_top flex FlexBetween">
                <div class="">
                    <div>参考答案：</div>
                    <div class="flex FlexWrap" v-for="(item, index) in topicInfo.questionContext.subQuestions"
                        :key="index">
                        <div>{{ `第${index + 1}小题答案` }}：</div>
                        <div>{{ getAnswer(item, "answer") }}</div>
                    </div>
                    <div class="mt-10">你的答案</div>
                    <div class="flex FlexWrap" v-for="(item, index) in topicInfo.questionContext.subQuestions"
                        :key="index">
                        <div>{{ `第${index + 1}小题答案` }}：</div>
                        <div>{{ getAnswer(item, "doAnswer") }}</div>
                    </div>
                </div>
                <!-- <div class="btn_ask">提问</div> -->
            </div>
            <div class="question_analyze mar_top_10">【试题分析】</div>
            <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-mathml></div>
            <div class="question_analyze mar_top_10">【解析】</div>
            <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-mathml></div>
        </div>
    </div>
</template>

<script>
import choice from "./subQuetion/choice.vue";
import multipleChoice from "./subQuetion/multipleChoice.vue";
import fillIn from "./subQuetion/fillIn.vue";
import sortNew from "./subQuetion/sortNew.vue";
import trueOrFalse from "./subQuetion/trueOrFalse.vue";
import textAnswer from "./subQuetion/textAnswer.vue";
export default {
    name: "GjkcH5Fillin",
    props: {
        questionInfo: {},
        videoQuestionInfo: {}
    },
    components: { choice, multipleChoice, fillIn, sortNew, trueOrFalse, textAnswer },

    data() {
        return {
            topicInfo: {},
        };
    },
    watch: {
        questionInfo: {
            handler(val) {
                if (val) {
                    console.log(val)
                    this.topicInfo = this.questionInfo;
                }
            },
            deep: true,
            immediate: true
        }
    },

    mounted() { },

    methods: {
        getAnswer(info, type) {
            let result = "";
            let answer = info.answer;
            if (type == "doAnswer") {
                answer = info.doAnswer;
            }
            // 单选题答案
            if (info.type == 1 || info.type == 9) {
                result = this.getChoiceLabel(answer, info.options);
            } else if (info.type == 2) {
                // 多选
                result = this.getMuitipleChoiceLabel(answer, info.options);
            } else if (info.type == 4 || info.type == 11) {
                // 判断
                if (answer == "") {
                    return "";
                }
                result = answer == "true" ? "对" : "错";
            } else if (info.type == 3 || info.type == 14) {
                // 填空
                result = this.getFillLabel(info.options, type);
            } else if (info.type == 6 || info.type == 15) {
                // 排序
                result = answer;
            } else if (info.type == 7 || info.type == 16 || info.type == 13 || info.type == 17) {
                // 排序
                result = answer;
            }
            return result;
        },
        // 单选题答案转换
        getChoiceLabel(value, options) {
            let label = "";
            options.forEach((item) => {
                if (item.serial == value) {
                    label = item.label;
                }
            });
            return label;
        },
        // 多选题答案转换
        getMuitipleChoiceLabel(value, options) {
            if (!options) return;
            // 多选多个答案拼接
            if (typeof value == "string") {
                value = value.split(",");
            }
            let label = "";
            options.forEach((item) => {
                value.forEach((sitem) => {
                    if (item.serial == sitem) {
                        label += item.label;
                    }
                });
            });
            return label;
        },
        // 填空题答案转换
        getFillLabel(options, type) {
            if (!options) return;
            let label = "";
            options.forEach((item, index) => {
                label += `填空${index + 1}：${type == 'doAnswer' ? item.doAnswer : item.content}、`
            });
            return label.slice(0, -1);
        },
        getAudioUrl(info) {
            let ruleInfo = this.$Tools.jsonDecode(info);
            if (!this.$Tools.empty(ruleInfo)) {
                return ruleInfo.listeningRule?.audioUrl
            }
        },
        viewAnalysis() {
            this.topicInfo.showAnalysis = true;
        },
        // 提交
        submit() {
            this.topicInfo.answerTimeSection = this.$Tools.jsonEncode(this.topicInfo.answerTimeSection);
            this.topicInfo.questionContext.subQuestions =
                this.topicInfo.questionContext.subQuestions.map((item) => {
                    if (item.type == 2) {
                        let aaa = this.$Tools.copyObj(item);
                        // 判断题处理数据格式
                        if (Array.isArray(aaa.answer)) {
                            aaa.answer = aaa.answer.join(",")
                        }
                        if (Array.isArray(aaa.doAnswer)) {
                            aaa.doAnswer = aaa.doAnswer.join(",")
                        }
                        return aaa
                    } else {
                        return item
                    }
                });
            let params = {
                paperId: this.videoQuestionInfo.paperId,
                examId: this.videoQuestionInfo.examId,
                examScene: 5,
                isSubmit: 1,
                questions: [this.topicInfo]
            }
            this.$Api.exam.submitVideoQuestion(params).then(res => {
                console.log(res);
                this.$Dialog.toast("提交成功");
                this.viewAnalysis();
            }).catch(() => { })
        },
        // 答题(刷新缓存试题便于提交)
        answerQuestion(info) {
            // 判断试题内容是否存在
            if (this.topicInfo.questionContext) {
                // 使用 map 生成新数组，直接替换原数组
                this.topicInfo.questionContext.subQuestions =
                    this.topicInfo.questionContext.subQuestions.map((item) => {
                        console.log(item)
                        console.log(info)
                        if (item.questionId == info.questionId) {
                            return this.$Tools.copyObj(info); // 替换匹配项
                        }
                        return item; // 保留其他项
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    min-height: 360px;

    .topic_type {
        // margin-top: 1rem;
        // width: 45px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {

        // overflow-x: auto;
        // overflow-y: clip;
        .topic_title {
            font-size: 16px;
            color: #242324;
            font-weight: 600;
        }
    }
}

.topic_select_none {
    min-height: auto;
}

.bottom_box {
    // position: absolute;
    // left: calc(50% - 60px);
    // bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
        margin: 0 auto;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    // height: 222px;
    background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .answer_top {
        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}
</style>